import { InvoiceApiResp, InvoiceJSON, ReservationJSON } from '../types/json_types';
import Invoice from '../models/Invoice';
import Reservation from '../models/Reservation';
import { UpdateArrivalPageState, UpdateDeparturePageState, UpdateRoomPageState } from '../types/state_types';
import { then } from '../util/util';
import { departureDateStrForSchool } from '../util/app_util';

export const processInvoiceJSON = (invoice_json: InvoiceJSON, res_json: ReservationJSON): Invoice => {
  const res = new Reservation(res_json);

  const invoice = new Invoice(invoice_json, res);

  return invoice;
};

export const getStateForRoomUpdate = (token: string, i: Invoice | null, json?: InvoiceApiResp): UpdateRoomPageState => {
  const res = i?.reservation;

  return {
    success: false,
    working: false,
    invoice_token: token,
    invoice: i || null,
    building_id: res?.building_id || null,
    room_number: res?.room_number || null,
    room_wing: res?.room_wing || null,
    delivered_room: json?.delivered_room || null,
    // nothing's shown until the invoice loads, so the form stays closed until the
    // server says otherwise
    room_updates_open: json?.room_updates_open || false,
  };
};

export const getStateForArrivalUpdate = (token: string, i: Invoice | null): UpdateArrivalPageState => {
  const res = i?.reservation;

  return {
    success: false,
    working: false,
    invoice_token: token,
    invoice: i || null,
    arrival_date_at: res?.arrival_date_at || null,
  };
};

export const getStateForDepartureUpdate = (token: string, i: Invoice | null): UpdateDeparturePageState => {
  const dateStr = then(i?.reservation, (r): string => {
    if (r && r.departure_date) {
      let d = r.departure_date.replace('2021', '2023')
      d = r.departure_date.replace('2022', '2023')
      return d;
    } else if (r) {
      return departureDateStrForSchool(r.school_id);
    } else {
      return '2023-04-15';
    }
  });

  return {
    success: false,
    working: false,
    invoice_token: token,
    invoice: i || null,
    departure_date: dateStr,
  };
};
